"use client";

import { useEffect, useRef } from "react";

import { useClientContext } from "@/shared/components/Context";

interface Props {
  children: React.ReactNode;
}

export default function VisibilityTracker({ children }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  const clientContext = useClientContext();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const isVisible = entry.isIntersecting;
        clientContext.setWelcomeVisible(!isVisible);
        clientContext.setWelcomeHeight(ref.current?.offsetHeight || 0);
      },
      {
        root: null,
        threshold: 0,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    const current = ref.current;

    return () => {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, [clientContext]);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      {children}
    </div>
  );
}
